"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllianceLeadPublicCreateTransport = exports.LeadSource = exports.AllianceLeadUpdateTransport = exports.AllianceLeadCreateTransport = exports.LeadCheckoutTransport = exports.AllianceLeadTransport = exports.PreferredContactMethod = exports.AllianceContactEventCreateTransport = exports.AllianceContactEvent = exports.AllianceLeadPublicQuoteCreateTransport = exports.AllianceLeadQuoteCreateTransport = exports.AllianceLeadQuote = exports.AllianceLeadHaulerQuoteCreateTransport = exports.AllianceLeadHaulerQuote = exports.AllianceLeadInternalNoteCreateTransport = exports.AllianceLeadInternalNote = exports.LeadStatusLabels = exports.LeadStatus = exports.LeadStatuses = exports.LeadTypeLabels = exports.LeadType = exports.LeadTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
const nullable_1 = require("../common/nullable");
const pricing_1 = require("../pricing");
const address_transport_1 = require("./address-transport");
const base_customer_1 = require("./base-customer");
const business_category_1 = require("./business-category");
const customer_type_1 = require("./customer-type");
const duration_transport_1 = require("./duration-transport");
const s3_item_reference_1 = require("./s3-item-reference");
exports.LeadTypes = ['rollOff', 'commercial', 'residential', 'portableToilet'];
exports.LeadType = typebox_1.Type.Union(exports.LeadTypes.map((t) => typebox_1.Type.Literal(t)));
exports.LeadTypeLabels = {
    rollOff: 'Roll Off',
    commercial: 'Commercial',
    residential: 'Residential',
    portableToilet: 'Portable Toilet',
};
exports.LeadStatuses = ['open', 'won', 'lost'];
exports.LeadStatus = typebox_1.Type.Union(exports.LeadStatuses.map((t) => typebox_1.Type.Literal(t)));
exports.LeadStatusLabels = {
    open: 'Open',
    won: 'Won',
    lost: 'Lost',
};
exports.AllianceLeadInternalNote = typebox_1.Type.Object({
    note: typebox_1.Type.String(),
    timestamp: typebox_1.Type.String(),
    userID: typebox_1.Type.String({ format: 'uuid' }),
});
exports.AllianceLeadInternalNoteCreateTransport = typebox_1.Type.Object({
    note: typebox_1.Type.String(),
});
exports.AllianceLeadHaulerQuote = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    active: typebox_1.Type.Boolean(),
    billingFrequency: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    serviceTypeID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    serviceFamilyID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    frequency: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    haulerID: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String({ format: 'uuid' }))),
    haulerName: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    material: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    price: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Number())),
    priceDollars: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Number())),
    quantity: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Number())),
    size: typebox_1.Type.Object({
        size: typebox_1.Type.Number(),
        type: typebox_1.Type.String(),
    }),
    metadata: typebox_1.Type.Object({
        createdAt: typebox_1.Type.String(),
        createdByUserID: typebox_1.Type.String(),
        lastUpdatedAt: typebox_1.Type.String(),
        lastUpdatedByUserID: typebox_1.Type.String(),
    }),
});
exports.AllianceLeadHaulerQuoteCreateTransport = typebox_1.Type.Omit(exports.AllianceLeadHaulerQuote, ['id', 'active', 'metadata']);
exports.AllianceLeadQuote = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    active: typebox_1.Type.Boolean(),
    size: typebox_1.Type.Object({
        size: typebox_1.Type.Number(),
        type: typebox_1.Type.String(),
    }),
    material: typebox_1.Type.String(),
    cc: typebox_1.Type.Boolean(),
    ccRate: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Number())),
    dumpRate: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Number())),
    dumpRateDollars: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Number())),
    price: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Number())),
    priceDollars: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Number())),
    priceType: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    tonLimit: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Number())),
    taxable: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Boolean())),
    taxRate: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Number())),
    overage: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Number())),
    overageDollars: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Number())),
    discountApplied: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Number())),
    discountAppliedDollars: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Number())),
    rentExtensionFee: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Number())),
    rentExtensionFeeDollars: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Number())),
    rentPeriod: typebox_1.Type.Optional((0, nullable_1.Nullable)(duration_transport_1.DurationTransport)),
    round: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Boolean())),
    pricingExists: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Boolean())),
    frequency: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    quantity: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Number())),
    billingFrequency: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    serviceTypeID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    serviceFamilyID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    pricingZoneID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    maxRentalDaysAllowed: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    signed: typebox_1.Type.Optional(typebox_1.Type.String()),
    metadata: typebox_1.Type.Object({
        createdAt: typebox_1.Type.String(),
        createdByUserID: typebox_1.Type.String(),
        lastUpdatedAt: typebox_1.Type.String(),
        lastUpdatedByUserID: typebox_1.Type.String(),
    }),
});
exports.AllianceLeadQuoteCreateTransport = typebox_1.Type.Omit(exports.AllianceLeadQuote, ['id', 'active', 'metadata']);
exports.AllianceLeadPublicQuoteCreateTransport = typebox_1.Type.Omit(exports.AllianceLeadQuote, [
    'id',
    'active',
    'metadata',
    'pricingExists',
    // Leave off all price fields, since this comes from unauthenticated user input, and we don't trust it.
    'cc',
    'ccRate',
    'dumpRate',
    'dumpRateDollars',
    'price',
    'priceDollars',
    'taxRate',
    'overage',
    'overageDollars',
    'discountApplied',
    'discountAppliedDollars',
    'rentExtensionFee',
    'rentExtensionFeeDollars',
]);
exports.AllianceContactEvent = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    medium: typebox_1.Type.String(),
    date: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    metadata: typebox_1.Type.Object({
        createdAt: typebox_1.Type.String(),
        createdByUserID: typebox_1.Type.String(),
        lastUpdatedAt: typebox_1.Type.String(),
        lastUpdatedByUserID: typebox_1.Type.String(),
    }),
});
exports.AllianceContactEventCreateTransport = typebox_1.Type.Omit(exports.AllianceContactEvent, ['id', 'metadata']);
exports.PreferredContactMethod = typebox_1.Type.Union([typebox_1.Type.Literal('EMAIL'), typebox_1.Type.Literal('PHONE'), typebox_1.Type.Literal('TEXT')]);
exports.AllianceLeadTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    firstName: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    lastName: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    company: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    email: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    phoneNumber: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    preferredContactMethod: typebox_1.Type.Optional((0, nullable_1.Nullable)(exports.PreferredContactMethod)),
    customer: typebox_1.Type.Optional(base_customer_1.BaseCustomer),
    images: typebox_1.Type.Array(s3_item_reference_1.S3ItemReference),
    motivation: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    notesInternal: typebox_1.Type.Array(exports.AllianceLeadInternalNote),
    serviceLocation: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Object({
        address: typebox_1.Type.Partial(address_transport_1.AddressTransport),
        coordinates: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Object({
            lat: typebox_1.Type.Number(),
            lng: typebox_1.Type.Number(),
        }))),
        county: typebox_1.Type.String(),
    }))),
    locationType: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    followUpDate: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    customerNotes: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    formUrl: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    referringUrl: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    channel: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    customerType: typebox_1.Type.Optional((0, nullable_1.Nullable)(customer_type_1.CustomerType)),
    businessCategory: typebox_1.Type.Optional((0, nullable_1.Nullable)(business_category_1.BusinessCategory)),
    searchParams: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    quotes: typebox_1.Type.Array(exports.AllianceLeadQuote),
    contactEvents: typebox_1.Type.Array(exports.AllianceContactEvent),
    type: exports.LeadType,
    status: exports.LeadStatus,
    requestedDeliveryDate: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    requestedSize: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Object({
        size: typebox_1.Type.Number(),
        type: typebox_1.Type.String(),
    }))),
    requestedMaterial: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    reasonLost: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    reasonLostNote: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    currentHauler: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    requestedStartDate: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    haulerQuotes: typebox_1.Type.Array(exports.AllianceLeadHaulerQuote),
    needsAttention: typebox_1.Type.Boolean(),
    affiliateTrackingID: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    quotePriceSeen: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Boolean())),
    accountRepID: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String({ format: 'uuid' }))),
    accountRepName: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    metadata: typebox_1.Type.Object({
        createdAt: typebox_1.Type.String(),
        createdByUserID: typebox_1.Type.String(),
        lastUpdatedAt: typebox_1.Type.String(),
        lastUpdatedByUserID: typebox_1.Type.String(),
    }),
});
exports.LeadCheckoutTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    quotes: typebox_1.Type.Array(exports.AllianceLeadQuote),
    serviceLocation: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Object({
        address: typebox_1.Type.Optional(pricing_1.QuotePartialAddress),
        county: typebox_1.Type.Optional(typebox_1.Type.String()),
        coordinates: typebox_1.Type.Optional(typebox_1.Type.Object({
            lat: typebox_1.Type.Optional(typebox_1.Type.Number()),
            lng: typebox_1.Type.Optional(typebox_1.Type.Number()),
        })),
    }))),
    requestedDeliveryDate: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.String({ format: 'date' }), typebox_1.Type.String({ format: 'date-time' }), typebox_1.Type.Null()])),
    customerInfo: typebox_1.Type.Object({
        company: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
        firstName: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
        lastName: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
        email: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
        phoneNumber: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
    }),
});
exports.AllianceLeadCreateTransport = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.AllianceLeadTransport, [
        'id',
        'customer',
        'notesInternal',
        'quotes',
        'contactEvents',
        'haulerQuotes',
        'metadata',
        'images',
    ]),
    typebox_1.Type.Object({
        customerID: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String({ format: 'uuid' }))),
        images: typebox_1.Type.Optional(typebox_1.Type.Array(s3_item_reference_1.S3ItemReference)),
    }),
]);
exports.AllianceLeadUpdateTransport = typebox_1.Type.Intersect([
    typebox_1.Type.Partial(typebox_1.Type.Omit(exports.AllianceLeadTransport, [
        'id',
        'customer',
        'notesInternal',
        'quotes',
        'contactEvents',
        'haulerQuotes',
        'metadata',
    ])),
    typebox_1.Type.Object({
        customerID: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String({ format: 'uuid' }))),
        images: typebox_1.Type.Optional(typebox_1.Type.Array(s3_item_reference_1.S3ItemReference)),
    }),
]);
/**
 * Where a public lead came from, as written to HubSpot's lead_source_custom property.
 *
 * A union rather than a string because the endpoint is unauthenticated: a free-text field would
 * let any caller write arbitrary values into a property the sales team reports on. Each value
 * must also exist as an option on the HubSpot property before it is used.
 */
exports.LeadSource = typebox_1.Type.Union([typebox_1.Type.Literal('Website'), typebox_1.Type.Literal('Website - Invoice Grader')]);
exports.AllianceLeadPublicCreateTransport = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.AllianceLeadTransport, [
        'id',
        'customer',
        'images',
        'notesInternal',
        'quotes',
        'contactEvents',
        'haulerQuotes',
        'followUpDate',
        'status',
        'needsAttention',
        'metadata',
        'accountRepID',
        'accountRepName',
    ]),
    typebox_1.Type.Object({
        quotes: typebox_1.Type.Optional(typebox_1.Type.Array(exports.AllianceLeadPublicQuoteCreateTransport)),
        status: typebox_1.Type.Optional(exports.LeadStatus),
        leadSource: typebox_1.Type.Optional(exports.LeadSource),
    }),
]);
//# sourceMappingURL=alliance-lead-transport.js.map